import { EditorWidget } from '@enerex/template-studio';
import '@enerex/template-studio/template-studio.css';
import getConfig from 'config';

import { useAuth } from 'providers/CustomAuthProvider';

const TemplateStudio = () => {
    const { user, clientId, isAdmin } = useAuth();
    const settings = getConfig().TemplateStudio;

    if (!settings.apiKey || !settings.clientId || !settings.meBaseUrl) {
        return <p role="status">Template Studio is not configured. Please contact your administrator.</p>;
    }

    if (!clientId || !user?.email || isAdmin == null) {
        return <p role="status">Loading Template Studio…</p>;
    }

    return (
        <section aria-labelledby="template-studio-title">
            <h4 id="template-studio-title">Template Studio</h4>
            <EditorWidget
                // The package initializes its configuration and query cache on mount.
                // Reset both when switching company, user, or permissions.
                key={JSON.stringify([clientId, user.email, isAdmin, settings])}
                config={{
                    ...settings,
                    enerexIdentifier: "00000000-0000-0000-0000-000000000000",
                    userEmail: user.email,
                    isAdmin: true,
                }}
            />
        </section>
    );
};

export default TemplateStudio;
